import { render, staticRenderFns } from "./OrderBreadcrumbs.vue?vue&type=template&id=7435404f&"
import script from "./OrderBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./OrderBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports